import React, { useRef } from "react";
import { formatMessage } from "../utils/generic";
import { AgentAudio, CustomerAudio } from "../../styles";

let currentlyPlayingAudio = null;

export default function Audio({ message }) {
    const audioRef = useRef(null);

    const handlePlay = () => {
        if (currentlyPlayingAudio && currentlyPlayingAudio !== audioRef.current) {
            currentlyPlayingAudio.pause();
        }
        currentlyPlayingAudio = audioRef.current;
    };

    const AudioComponentWrapper = message.from === "customer" ? CustomerAudio : AgentAudio;
    const caption = (message && message.content && message.content.caption) || "";

    return (
        <AudioComponentWrapper className={message.from}>
            <audio ref={audioRef} controls className="max-w-full" onPlay={handlePlay}>
                <source src={message.content.link} />
                Your browser does not support the audio tag.
            </audio>
            <p className="caption" dangerouslySetInnerHTML={{ __html: formatMessage(caption) }} />
        </AudioComponentWrapper>
    );
}



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/AssistComponents/AudioTemp.js